import { Component, OnInit } from '@angular/core';
import { PopoverListItem } from '../popover/popover.page';

export interface PopoverCheckListItem extends PopoverListItem {
  checked?: boolean
}

@Component({
    selector: 'app-checkbox-select',
    templateUrl: './checkbox-select.component.html',
    styleUrls: ['./checkbox-select.component.scss'],
    standalone: false
})
export class CheckboxSelectComponent implements OnInit {

  public list: PopoverCheckListItem[] = []
  public itemChecked: (item: PopoverCheckListItem) => void

  constructor() { }

  ngOnInit() {}

}
